import {colors} from 'lib/colors';

// Fraud risk thresholds (0-100 display scale)
// Based on AWS Fraud Detector model performance data:
// - 50: broad detection net for medium-risk flagging
// - 95: ~84% precision, 1% FPR — high confidence
export const MEDIUM_RISK_THRESHOLD = 50;
export const HIGH_RISK_THRESHOLD = 95;

export type RiskType = 'success' | 'warning' | 'danger';

/** Convert API score (0-1000) to display score (0-100) */
export const toDisplayScore = (apiScore: number): number =>
  Math.round(Math.max(0, Math.min(1000, apiScore)) / 10);

export const isMediumRisk = (displayScore: number): boolean =>
  displayScore >= MEDIUM_RISK_THRESHOLD && displayScore < HIGH_RISK_THRESHOLD;

export const isHighRisk = (displayScore: number): boolean => displayScore >= HIGH_RISK_THRESHOLD;

export const isMediumOrHighRisk = (displayScore: number): boolean =>
  displayScore >= MEDIUM_RISK_THRESHOLD;

export const getRiskType = (displayScore: number): RiskType =>
  displayScore < MEDIUM_RISK_THRESHOLD
    ? 'success'
    : displayScore < HIGH_RISK_THRESHOLD
      ? 'warning'
      : 'danger';

export const getRiskColor = (displayScore: number): string =>
  displayScore < MEDIUM_RISK_THRESHOLD
    ? '#52c41a'
    : displayScore < HIGH_RISK_THRESHOLD
      ? colors.warning
      : '#ff4d4f';

export const getRiskSummary = (displayScore: number): string => {
  if (displayScore >= HIGH_RISK_THRESHOLD)
    return 'This payment shows strong risk signals and is likely to be fraudulent.';
  if (displayScore >= MEDIUM_RISK_THRESHOLD)
    return 'This payment shows moderate risk signals. Additional review is recommended.';
  return 'This payment shows low risk based on the available signals. Additional review is typically not required.';
};

export const getRiskDescription = (displayScore: number): string =>
  `Risk score: ${String(displayScore)} / 100. ${getRiskSummary(displayScore)}`;
